// FileUploadBase.js

import { DEFAULT_ALLOWED_FILE_TYPES } from "../../../../classes/constants/fileConstants";
import { groupFilesById } from "../../../../classes/utils/FileUtils";
import { useFileManagement } from "../../../../hooks/useFileManagement";
import DragDropArea from "../deagAndDroArea/DragDropArea";
import UploadedFilesList from "../uploadedFileList/UploadedFilesList";
import "./FileUploadBase.css";

const FileUploadBase = ({
  uploadedFiles,
  setUploadedFiles,
  isImporting,
  setIsImporting,
  importProgress,
  setImportProgress,
  allowedFileTypes = DEFAULT_ALLOWED_FILE_TYPES,
  onProceed,
  proceedButtonText = "Proceed to Validation",
  showProceedButton = true,
  className = "",
  fileHandlers = null,
}) => {
  const { addFiles, removeFile } = useFileManagement({
    uploadedFiles,
    setUploadedFiles,
    allowedFileTypes,
    setIsImporting,
    setImportProgress,
  });

  const resolvedAddFiles = fileHandlers?.addFiles || addFiles;
  const resolvedRemoveFile = fileHandlers?.removeFile || removeFile;

  const { groups: groupedFiles } = groupFilesById(uploadedFiles);

  return (
    <div className={`file-upload-base ${className}`}>
      <div className="upload-section">
        <DragDropArea
          onAddFiles={resolvedAddFiles}
          allowedFileTypes={allowedFileTypes}
          isImporting={isImporting}
        />
        {uploadedFiles.length > 0 && (
          <UploadedFilesList
            groupedFiles={groupedFiles}
            onRemoveFile={resolvedRemoveFile}
            isImporting={isImporting}
          />
        )}
      </div>

      {showProceedButton &&
        uploadedFiles.length > 0 &&
        groupedFiles.length > 0 && (
          <button
            className="proceed-button"
            onClick={onProceed}
            disabled={isImporting}
          >
            {proceedButtonText}
          </button>
        )}
    </div>
  );
};

export default FileUploadBase;
